import { render, staticRenderFns } from "./LeitorPdfFerramenta.vue?vue&type=template&id=61a04a4a&scoped=true"
import script from "./LeitorPdfFerramenta.vue?vue&type=script&lang=js"
export * from "./LeitorPdfFerramenta.vue?vue&type=script&lang=js"
import style0 from "./LeitorPdfFerramenta.vue?vue&type=style&index=0&id=61a04a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a04a4a",
  null
  
)

export default component.exports